module.exports = __webpack_public_path__ + "static/media/zumbat-logo.d6572dc9.png";